import React from 'react'
import { connect } from 'react-redux'
import { func, string } from 'prop-types'

import { getChangePasswordStatus } from 'models/user/selectors'
import { requestChangePassword } from 'models/user/actions'

import ChangePassword from 'components/accountAccess/ChangePassword'

const ChangePasswordContainer = ({ changePassword, changePasswordStatus, onClose }) => (
    <ChangePassword changePassword={changePassword} changePasswordStatus={changePasswordStatus} onClose={onClose} />
)

ChangePasswordContainer.propTypes = {
    changePassword: func.isRequired,
    changePasswordStatus: string.isRequired,
    onClose: func.isRequired,
}

const mapStateToProps = (state) => ({
    changePasswordStatus: getChangePasswordStatus(state),
})

const mapDispatchToProps = (dispatch) => ({
    changePassword: (currentPassword, newPassword) => dispatch(requestChangePassword(currentPassword, newPassword)),
})

export default connect(mapStateToProps, mapDispatchToProps)(ChangePasswordContainer)
